module.exports = __webpack_public_path__ + "img/Dark Mode@4x-8.bcad9af6.png";